export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/val-vesa-7af098f196594c9a0e5934c5362c43f5.jpg";